import get from 'lodash/get'
import isNull from 'lodash/isNull'

import {createSelector} from 'reselect'

import {
  HTO_CATEGORIES,
  PRODUCT_NAME_LINE_BREAK,
  TRANSACTION_TYPE_RENT,
  TRANSACTION_TYPE_RENT_ADD,
} from '../const'

const isHto = (x) => get(x, 'setSpecs.isHto', false)
const isKit = (x) => get(x, 'setType') === 'kit'

const productCategoryPage = (state) => get(state, 'productCategoryPage')
const productDetailPage = (state) => get(state, 'productDetailPage')
export const product = (state) => get(state, 'product.displayedProduct')

// PDP
export const callBack = (state) => get(productDetailPage(state), 'callBack')
export const currentZoomImageIndex = (state) =>
  get(state, 'productDetailPage.currentZoomImageIndex')
export const isZoomedIn = (state) => get(state, 'productDetailPage.isZoomedIn')
export const partyAvailableModalIsOpen = (state) =>
  get(state, 'productDetailPage.partyAvailableModalIsOpen')
export const soldOutModalIsOpen = (state) => get(state, 'productDetailPage.soldOutModalIsOpen')
export const manuallySelectedTransactionType = (state) =>
  get(state, 'productDetailPage.manuallySelectedTransactionType')
export const zoomModalIsOpen = (state) => get(state, 'productDetailPage.zoomModalIsOpen')

// PCP
export const category = (state) => get(productCategoryPage(state), 'displayedCategory')

// Product
export const productSetSpecs = (state) => get(product(state), 'setSpecs')
export const productBuyPrice = (state) => get(product(state), 'buyPrice')
export const productCategorySlug = (state) =>
  get(productSetSpecs(state), 'defaultDisplayCategorySlug')
export const productId = (state) => get(product(state), 'id')
export const productIsPurchasable = (state) => get(product(state), 'isPurchasable')
export const productIsRentable = (state) => get(product(state), 'isRentable')
export const productIsRetired = (state) => get(product(state), 'isRetired')
export const productName = (state) => get(product(state), 'name')
export const productDefaultImage = (state) => get(product(state), 'setImages[0].url')
export const productDescription = (state) => get(product(state), 'description')
export const productRentPrice = (state) => get(product(state), 'rentPrice')
export const productSeoDescription = (state) => get(productSetSpecs(state), 'seoTag')
export const productSetType = (state) => get(product(state), 'setType')
export const productSlug = (state) => get(product(state), 'slug')
export const productUrlSlug = (state) => get(product(state), 'urlSlug')
export const buyProductSoldOutPeriods = (state) => get(product(state), 'buySoldoutPeriods')
export const rentProductSoldOutPeriods = (state) => get(product(state), 'rentSoldoutPeriods')
export const setChildren = (state) => get(product(state), 'setChildren')
export const setImages = (state) => get(product(state), 'setImages')
export const sizing = (state) => get(productSetSpecs(state), 'sizing')
export const tags = (state) => get(product(state), 'tags')
export const buttonTransactionType = (_, props) => get(props, 'transactionType')

// Computed

/**
 * Only returns images of the product and/or the model; filters out other image
 * types such as `still-life`.
 * @returns {Array} An array of image objects
 */
export const productAndModelImages = createSelector(setImages, (images = []) =>
  images.filter(({contentType}) => ['product', 'model'].includes(contentType)),
)

export const productHasLoaded = createSelector(product, ($product) => !isNull($product))

export const productCollectionPageUrl = createSelector(
  productCategorySlug,
  (categorySlug) => `/collections/${categorySlug}`,
)

export const productPageUrl = createSelector(
  productCategorySlug,
  productUrlSlug,
  (prod) => `/products/${prod}`,
)

export const productNameLineBreak = createSelector(
  productName,
  (name) => name.length > PRODUCT_NAME_LINE_BREAK,
)

export const currentZoomImage = createSelector(
  setImages,
  currentZoomImageIndex,
  (images, index) => images[index].url,
)

export const productIsHto = createSelector(product, (displayedProduct) => isHto(displayedProduct))

export const productCategoryIsHto = createSelector(productCategorySlug, (categorySlug) =>
  HTO_CATEGORIES.includes(categorySlug),
)

export const productIsKit = createSelector(product, (displayedProduct) => isKit(displayedProduct))

export const productIsOutfit = createSelector(productSetType, (setType) => setType === 'group')

export const productIsSuitTuxedo = createSelector(productSetType, (setType) => setType === 'kit')

export const productIsKitOrGroup = createSelector(
  productSetType,
  (setType) => setType === 'kit' || setType === 'group',
)

export const addedProductObject = createSelector(
  productBuyPrice,
  productId,
  productName,
  productRentPrice,
  (buyPrice, id, name, rentPrice) => ({buyPrice, id, name, rentPrice}),
)

// Per transaction type

export const productPriceForTransactionType = createSelector(
  buttonTransactionType,
  productRentPrice,
  productBuyPrice,
  (buttonType, rentPrice, buyPrice) =>
    buttonType === TRANSACTION_TYPE_RENT || buttonType === TRANSACTION_TYPE_RENT_ADD
      ? rentPrice
      : buyPrice,
)

export const isOfferedForTransactionType = createSelector(
  buttonTransactionType,
  productIsPurchasable,
  (buttonType, isPurchasable) =>
    buttonType === TRANSACTION_TYPE_RENT || buttonType === TRANSACTION_TYPE_RENT_ADD
      ? true
      : isPurchasable,
)
